
<label *ngIf="type === 'cccard'">{{'SHARED.paymentModal.creditCardNumberLabel' | translate}}</label>
<label *ngIf="type === 'sepa'">IBAN</label>
<div id="card-element" class="form-control" #cardElement>
<!-- a Stripe Element will be inserted here. -->
</div>
<small class="py-1" id="mandate-acceptance" *ngIf="type === 'sepa'">
    {{'SHARED.paymentModal.mandateAcceptance' | translate}}
</small>
<div class="invalid-feedback" *ngIf="cardErrors">
    {{cardErrors}}
</div>

